module.exports = __webpack_public_path__ + "img/alo-kasko-footer-logo.e21ebf2d.svg";